import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import {
  actionGetTicketTypes,
  actionDeleteTicketType,
} from "../../actions/EventActions";
import {
  LOGIN_ROUTE,
  TICKET_TYPE_ADD_ROUTE,
  TICKET_TYPE_EDIT_ROUTE,
} from "../../config/RoutesConstants";
import {
  Container,
  IconButton,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/ArrowBackRounded";
import CopyIcon from "@material-ui/icons/FileCopy";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ColorIcon from "@material-ui/icons/FiberManualRecord";
import Util, { ERROR } from "../../common/Util";

class TicketTypes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowPerPage: 5,
      count: 0,
      tickets: [],
      filter: "",
      ticketForDelete: false,
    };
    this.renderTableHeader = this.renderTableHeader.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.getDeleteTicketSuccess = this.getDeleteTicketSuccess.bind(this);
    this.onAddTicket = this.onAddTicket.bind(this);
    this.onConfirmDeleteTicket = this.onConfirmDeleteTicket.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentWillMount() {
    if (!this.props.login) {
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetTicketTypes(this.onChangePage, this.getTicketsError);
  }

  getTicketsError(e) {
    console.log("ERROR AL LISTAR TICKETS", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tickets.");
  }

  onSearch(evt) {
    this.setState({ filter: evt.target.value }, this.onChangePage);
  }

  onChangePage(evt = null, newPage = 0) {
    let from = newPage * this.state.rowPerPage;
    let end = from + this.state.rowPerPage;
    let filter = new RegExp(this.state.filter, "ig");
    let tickets = this.props.ticketTypeList.filter((t) => {
      return t.tktDisplayName.match(filter);
    });
    let count = tickets.length;
    tickets = tickets.slice(from, end);
    this.setState({ page: newPage, count: count, tickets: tickets });
  }

  onChangeRowsPerPage(evt) {
    let from = this.state.page * evt.target.value;
    let end = from + evt.target.value;
    let filter = new RegExp(this.state.filter, "ig");
    let tickets = this.props.ticketTypeList.filter((t) => {
      return t.tktDisplayName.match(filter);
    });
    let count = tickets.length;
    tickets = tickets.slice(from, end);
    this.setState({
      rowPerPage: evt.target.value,
      count: count,
      tickets: tickets,
    });
  }

  onAddTicket() {
    this.props.history.push(TICKET_TYPE_ADD_ROUTE);
  }

  onEditTicket(ticket) {
    this.props.history.push(TICKET_TYPE_EDIT_ROUTE, ticket);
  }

  onCopyTicket(ticket) {
    delete ticket.id
    this.props.history.push(TICKET_TYPE_EDIT_ROUTE, ticket);
  }

  onConfirmDeleteTicket() {
    this.props.actionDeleteTicketType(
      this.state.ticketForDelete.id,
      this.getDeleteTicketSuccess,
      this.getDeleteTicketError
    );
    this.setState({ ticketForDelete: false });
  }

  onDeleteTicket(ticket) {
    this.setState({ ticketForDelete: ticket });
  }

  getDeleteTicketSuccess() {
    const event = this.props.event;
    // console.log("EVENT", event)
    this.props.actionGetTicketTypes(() => {
      this.onChangePage(null, this.state.page);
    }, this.getTicketsError);
  }

  getDeleteTicketError(e) {
    console.log("ERROR GET DELETE TICKET", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el ticket.");
  }

  renderTableHeader() {
    const { theme } = this.props;
    const headers = [
      "Nombre",
      "Tipo",
      "Precio",
      "Lote Total",
      "Disponibles",
      "Disponible desde",
      "Disponible hasta",
      "Status",
      "Color",
      "Creado por",
      "Modificado por",
    ];
    return (
      <TableRow>
        {headers.map((label) => {
          return <TableCell>{label}</TableCell>;
        })}
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }

  /* 
tktIcon
tktIconFamily

tktMaxQtBuy
tktName

tktPriceProducer
tktProducerName
  */

  renderTableBody() {
    const { theme } = this.props;
    let tickets = this.state.tickets;
    if (!tickets || tickets.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return tickets.map((item, index) => {
      let isActive = item.tktVisible;
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <Tooltip interactive enterDelay={10} title={item.id}>
            <TableCell>{item.tktDisplayName}</TableCell>
          </Tooltip>
          <TableCell>{item.tktCategory}</TableCell>
          <TableCell>{`$ ${Util.formatNumber(item.tktPrice)}`}</TableCell>
          <TableCell>{item.tktQtOriginal}</TableCell>
          <TableCell>{item.tktQt}</TableCell>
          <TableCell>
            {Util.formatDateToShow(Util.timestampToMoment(item.tktInitDate))}
          </TableCell>
          <TableCell>
            {Util.formatDateToShow(Util.timestampToMoment(item.tktEndDate))}
          </TableCell>
          <TableCell
            style={
              isActive
                ? theme.table.activeCell
                : theme.overrides.MuiTableCell.body
            }
          >
            {item.tktVisible ? "ACTIVO" : "INACTIVO"}
          </TableCell>
          <TableCell>
            <ColorIcon style={{ color: item.tktColor }} />
          </TableCell>
          <TableCell>{item.tktCreateUser}</TableCell>
          <TableCell>{item.tktLastUpdateUser}</TableCell>
          <TableCell style={{ ...theme.table.actionsColumn, minWith: 200 }}>
            <Tooltip title="Copiar tipo de ticket">
              <IconButton onClick={this.onCopyTicket.bind(this, item)}>
                <CopyIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar tipo de ticket">
              <IconButton onClick={this.onEditTicket.bind(this, item)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar tipo de ticket">
              <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    });
  }

  render() {
    const { theme, ticketTypeList, event } = this.props;
    return (
      <Box style={theme.mainContainer}>
        <Box
          style={{
            ...theme.title.container,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <Box style={theme.title.backIconContainer}>
            <IconButton
              onClick={this.props.history.goBack}
              style={theme.title.backIcon}
            >
              <BackIcon
                style={{ fontSize: "2.5rem" }}
                stroke="white"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">{event.evtName}</Typography>
            <Typography variant="subtitle1">
              Crea tipo de tickets para el evento seleccionado
            </Typography>
          </Box>
        </Box>
        <Container style={theme.table.container}>
          <Paper>
            <Typography style={theme.paper.title} variant="h2">
              Listado de tipos de tickets
            </Typography>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nuevo tipo de ticket">
                <Fab color="primary" onClick={this.onAddTicket} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch} />
              </Box>
            </Toolbar>
            <Table stickyHeader>
              <TableHead>{this.renderTableHeader()}</TableHead>
              <TableBody>{this.renderTableBody()}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.ticketForDelete}>
            <DialogTitle>Eliminar Tipo de Ticket</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el tipo de ticket?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ ticketForDelete: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar tipo de ticket">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmDeleteTicket}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    );
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    ticketTypeList: store.evt.ticketTypeList,
    event: store.evt.event,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTicketTypes,
      actionDeleteTicketType,
    },
    dispatch
  );
}

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(TicketTypes))
);



// WEBPACK FOOTER //
// ./src/screens/events/TicketTypes.js